import { AxiosResponse } from "axios";

import { IStandardFieldSetting } from "../@types/StandardField";
import { api } from "./api";

export const standardFieldsService = {
  // EN-5192: the union of the built-in onboarding fields' settings across the given wards —
  // which are shown and which are mandatory. wardIds are passed as repeated query params.
  async getStandardFieldsForWards(
    wardIds: number[]
  ): Promise<AxiosResponse<IStandardFieldSetting[]>> {
    const query = wardIds.map((id) => `wardIds=${id}`).join("&");
    const url = `/Portal/StandardFields/ForWards${query ? `?${query}` : ""}`;

    const serverResponse = await api.get<IStandardFieldSetting[]>(url);

    if (serverResponse !== undefined) {
      return serverResponse;
    }

    throw Error;
  },
};
